
import {Component, Emit, Mixins, Prop, Watch} from 'vue-property-decorator'
import {
  Address,
  Company,
  CompanyCollection,
  CompanyTypeEnum,
  PriceList,
  PriceListCollection,
  ProductTypeEnum,
  UserCollection
} from '@/firestore'
import AuthMixin from '@/mixins/AuthMixin.vue'
import PhoneNumber from '@/components/PhoneNumber.vue'
import AddressEdit from '@/components/Address/AddressEdit.vue'
import axios from 'axios'

@Component({
  components: {PhoneNumber, AddressEdit}
})
export default class AddVendorModal extends Mixins(AuthMixin) {
  @Prop({type: Boolean, default: false})
  public show!: boolean

  @Prop({type: Array, required: true})
  public vendors!: Company[]

  @Prop({type: Array, required: true})
  public priceLists!: PriceList[]

  public $refs!: {
    form: HTMLFormElement
  }

  public newVendorPayload: {
    vendorName: string,
    productTypes: ProductTypeEnum[],
    repName: string,
    phoneNumber: string,
    email: string,
    address: Address
  } = {
    vendorName: '',
    productTypes: [],
    repName: '',
    phoneNumber: '',
    email: '',
    address: {} as Address
  }
  public vendor: Company | null = null
  public priceList: PriceList | null = null
  public search: string = ''
  public vendorSelect: string | { text: string, value: PriceList | Company } = ''
  public items = [
    {
      text: '',
      value: {} as PriceList | Company
    }
  ]

  public productTypes: { name: string, value: ProductTypeEnum }[] = [
    {name: 'Alcohol', value: ProductTypeEnum.ALCOHOL},
    {name: 'Food', value: ProductTypeEnum.FOOD}
  ]

  public loadingVendors = false
  public savingVendor = false
  public loadingPhoneNumber = false
  public disabled = true
  public valid: boolean = false
  public errors: string[] = []

  @Watch('show')
  public async loadVendors() {
  }

  @Watch('vendorSelect')
  public async updatePayload() {
    if (
        !this.vendorSelect
        || typeof this.vendorSelect === 'string'
        || !this.vendorSelect.value
    ) {
      return
    }

    this.newVendorPayload.vendorName =
        this.isCompany(this.vendorSelect.value)
            ? this.vendorSelect.value.name
            : this.vendorSelect.value.vendorCompanyName

    if (this.isCompany(this.vendorSelect.value) && this.vendorSelect.value.address) {
      this.newVendorPayload.address = this.vendorSelect.value.address
    }

    if (this.isCompany(this.vendorSelect.value) && this.vendorSelect.value.productTypes) {
      this.newVendorPayload.productTypes = this.vendorSelect.value.productTypes
    }

    if (this.vendorSelect.value.id) {
      const priceListCollection = new PriceListCollection((await this.$firebase).firestore())

      if (this.isPriceList(this.vendorSelect.value)) {
        const priceList = this.vendorSelect.value
        if (priceList) {
          this.newVendorPayload.phoneNumber = priceList.vendorRepPhoneNumber
        }
      }
    }
  }

  @Watch('newVendorPayload.phoneNumber')
  public async lookupPhoneNumber() {
    if (!/^\+\d+[0-9]{3}[0-9]{3}[0-9]{4}$/.test(this.newVendorPayload.phoneNumber)) {
      this.disabled = true
      this.newVendorPayload.repName = ''
      this.newVendorPayload.email = ''
      return
    }

    this.loadingPhoneNumber = true

    const userCollection = new UserCollection((await this.$firebase).firestore())
    const user = await userCollection.getUserByPhone(this.newVendorPayload.phoneNumber)

    if (!user) {
      this.newVendorPayload.repName = ''
      this.newVendorPayload.email = ''
      this.disabled = false
    } else {
      this.newVendorPayload.repName = user.name
      this.newVendorPayload.email = user.email
    }

    this.loadingPhoneNumber = false
  }

  @Watch('search')
  public async updateVendorList(search: string) {
    if (!search) {
      const priceLists = this.priceLists.map(priceList => (
          {text: this.getDisplayName(priceList), value: priceList}
      ))

      return [
        ...priceLists,
        this.items = this.vendors.map(vendor => {
          const hasPriceList = priceLists.find(({value}) => value.vendorCompanyId === vendor.id)
          if (!hasPriceList) {
            return {text: vendor.displayName, value: vendor}
          }
        }) as { text: string, value: Company }[]
      ]
    }

    this.priceLists.forEach(priceList => {
      if (
          priceList.vendorCompanyName
          && (
              priceList.vendorCompanyName.toLowerCase().includes(search.toLowerCase())
              || priceList.vendorCompanyName.toLowerCase() === search.toLowerCase()
          )
      ) {
        this.items.push(
            {
              text: this.getDisplayName(priceList),
              value: priceList
            }
        )
      }
    })

    this.vendors.forEach(vendor => {
      if (
          vendor.name.toLowerCase().includes(search.toLowerCase())
          || vendor.name.toLowerCase() === search.toLowerCase()
      ) {
        const hasPriceList = this.items.find(item => (
            item && item.value && this.isPriceList(item.value)
                ? item.value.vendorCompanyId && item.value.vendorCompanyId === vendor.id
                : false
        ))

        if (!hasPriceList) {
          this.items.push(
              {
                text: vendor.displayName,
                value: vendor
              }
          )
        }
      }
    })
  }

  @Emit()
  public async confirmSave() {
    if (this.$refs.form) {
      this.errors = []

      if (this.newVendorPayload.productTypes && this.newVendorPayload.productTypes.length) {
        this.newVendorPayload.productTypes = this.newVendorPayload.productTypes.filter(type => type !== null)
      }

      if (!this.newVendorPayload.productTypes || !this.newVendorPayload.productTypes.length) {
        this.errors.push('Please enter at least one product type')
      }

      if (!this.$refs.form.validate()) {
        if (!this.newVendorPayload.vendorName) {
          this.errors.push('Please enter a vendor name')
        }
        if (!this.newVendorPayload.repName) {
          this.errors.push('Please enter your rep\'s name')
        }
        if (!this.newVendorPayload.phoneNumber) {
          this.errors.push('Please enter your rep\'s phone number')
        }
        if (!this.newVendorPayload.email) {
          this.errors.push('Please enter your rep\'s email')
        }
        if (!this.newVendorPayload.address.street) {
          this.errors.push('Please enter an address for your vendor')
        }
        if (!this.newVendorPayload.address.city) {
          this.errors.push('Please enter a city for your vendor')
        }
        if (!this.newVendorPayload.address.state) {
          this.errors.push('Please enter a state for your vendor')
        }
        if (!this.newVendorPayload.address.postalCode) {
          this.errors.push('Please enter a ZIP code for your vendor')
        }
      }
    }
    if (this.valid && !this.errors.length) {
      await this.addVendor()
      this.hide()
      this.saved()
    }
  }

  @Emit()
  public hide() {
    this.$refs.form.reset()
  }

  @Emit()
  public saved() {
    this.$refs.form.reset()
    return this.vendor
  }

  private async addVendor() {
    this.savingVendor = true

    if (
        this.vendorSelect
        && typeof this.vendorSelect !== 'string'
        && this.vendorSelect.value
        && this.vendorSelect.value.id
    ) {
      const vendorSelect = this.vendorSelect
      const priceListCollection = new PriceListCollection((await this.$firebase).firestore())
      const activePriceLists = await priceListCollection.listPriceListsByCompanyId(
          this.userCompany.id,
          CompanyTypeEnum.RESTAURANT,
          true
      )

      // Confirm you don't already have this vendor enabled
      if (
          activePriceLists.find(
              priceList =>
                  priceList.vendorCompanyId === vendorSelect.value.id
                  || priceList.id === vendorSelect.value.id
          )
      ) {
        this.savingVendor = false
        return
      }

      const companyCollection = new CompanyCollection((await this.$firebase).firestore())

      this.vendor = await companyCollection.getCompany(
          this.isPriceList(vendorSelect.value)
              ? vendorSelect.value.vendorCompanyId
              : vendorSelect.value.id
      )
    } else {
      await this.createVendor()
    }
    await this.updateVendorEmail()
    await this.updatePriceList()

    this.savingVendor = false
  }

  protected async createVendor() {
    const vendorName = typeof this.vendorSelect === 'string'
        ? this.vendorSelect
        : this.isCompany(this.vendorSelect.value)
            ? this.vendorSelect.value.name
            : this.vendorSelect.value.vendorCompanyName
    this.vendor = new Company(vendorName, CompanyTypeEnum.VENDOR)
    this.vendor.productTypes = this.newVendorPayload.productTypes
    this.vendor.address = this.newVendorPayload.address

    await axios.post('/api/vendors', this.vendor)
  }

  protected async updateVendorEmail() {
    if (!this.vendor) {
      return
    }

    const priceListCollection = new PriceListCollection((await this.$firebase).firestore())
    if (typeof this.vendorSelect !== 'string' && this.isPriceList(this.vendorSelect.value)) {
      this.priceList = this.vendorSelect.value
    }

    if (!this.priceList) {
      this.priceList = new PriceList(this.vendor.id, this.userCompany.id)
    }

    this.priceList.vendorRepPhoneNumber = this.newVendorPayload.phoneNumber.replace(/[\(\)\- ]+/g, '')
    this.priceList.vendorRepEmail = this.newVendorPayload.email
    this.priceList.vendorRepName = this.newVendorPayload.repName
    this.priceList.vendorCompanyName =
        typeof this.vendorSelect === 'string'
            ? this.vendorSelect
            : this.newVendorPayload.vendorName
    this.priceList.active = true

    if (!this.priceList) {
      return
    }

    const response = await axios.post(
        `/api/vendors/${this.vendor.id}/rep`,
        {
          email: this.priceList.vendorRepEmail,
          phoneNumber: this.priceList.vendorRepPhoneNumber,
          name: this.newVendorPayload.repName,
          productTypes: this.newVendorPayload.productTypes
        }
    ) as { data: { userId: string, userEmail: string, userPhoneNumber: string } }

    this.priceList.vendorRepId = response.data.userId
  }

  public async updatePriceList() {
    if (this.priceList) {
      const priceListCollection = new PriceListCollection((await this.$firebase).firestore())
      await priceListCollection.save({
        ...this.priceList,
        entries: this.priceList.entries.filter(entry => !entry.isBlank)
      } as PriceList)
    }
  }

  public getDisplayName(priceList: PriceList) {
    const vendor = this.vendors.find(v => v.id === priceList.vendorCompanyId)
    let displayName = ''

    if (vendor && vendor.displayName) {
      displayName = vendor.displayName
      if (priceList && priceList.vendorRepName) {
        return `${displayName} - ${priceList.vendorRepName}`
      }
    }

    return displayName
  }

  public isPriceList(priceList: any): priceList is PriceList {
    if (priceList instanceof PriceList) {
      return true
    }

    if (typeof priceList.id !== 'string') {
      return false
    }
    if (!priceList.entries || typeof priceList.entries !== 'object') {
      return false
    }
    if (!priceList.vendorCompanyId || typeof priceList.vendorCompanyId !== 'string') {
      return false
    }
    if (priceList.vendorRepName && typeof priceList.vendorRepName !== 'string') {
      return false
    }
    if (priceList.vendorCompanyName && typeof priceList.vendorCompanyName !== 'string') {
      return false
    }
    if (priceList.restaurantCompanyId && typeof priceList.restaurantCompanyId !== 'string') {
      return false
    }
    if (priceList.vendorRepEmail && typeof priceList.vendorRepEmail !== 'string') {
      return false
    }
    if (priceList.vendorRepPhoneNumber && typeof priceList.vendorRepPhoneNumber !== 'string') {
      return false
    }
    if (priceList.vendorRepId && typeof priceList.vendorRepId !== 'string') {
      return false
    }
    if (priceList.active && typeof priceList.active !== 'boolean') {
      return false
    }

    return true
  }

  public isCompany(company: any): company is Company {
    if (company instanceof Company) {
      return true
    }

    if (typeof company.id !== 'string') {
      return false
    }
    if (company.users && typeof company.users !== 'object') {
      return false
    }
    if (company.admins && typeof company.admins !== 'object') {
      return false
    }
    if (company.userRoles && typeof company.userRoles !== 'object') {
      return false
    }
    if (company.features && typeof company.features !== 'object') {
      return false
    }
    if (company.preferred && typeof company.preferred !== 'boolean') {
      return false
    }
    if (company.productTypes && typeof company.productTypes !== 'object') {
      return false
    }

    return true
  }
}
